import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import './icons' // icon
import './permission'

// day
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { menu } from '@/utils/menu'
import cookie from 'js-cookie'

// GA
import VueGtag from 'vue-gtag'

// driver
import 'driver.js/dist/driver.min.css'

// dayjs load utc plugin
dayjs.extend(utc)
dayjs.extend(customParseFormat)

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

Vue.filter('toLocalTime', function(value) {
  return dayjs
    .utc(value, 'YYYY-MM-DD HH:mm:ss')
    .local()
    .format('YYYY-MM-DD HH:mm:ss')
})

Vue.filter('formatPrice', function(value) {
  if (value && Number.isInteger(value)) {
    return 'NZD $' + parseFloat((value * 100) / 10000).toFixed(2)
  } else {
    return 'NZD $0.00'
  }
})

const globalMenu = cookie.get('globalMenu')
if (globalMenu) {
  router.addRoutes(menu(JSON.parse(globalMenu)))
}

// Add GA
const hostname = window.location.hostname
if (hostname === 'myshop.ieshop.co.nz') {
  Vue.use(VueGtag, {
    config: { id: 'G-1H4PSXDKG3' }
  })
} else if (hostname === 'myshop.nzmai.com.cn') {
  Vue.use(VueGtag, {
    config: { id: 'G-2TYJZCMFS2' }
  })
}

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  render: h => h(App)
})
